// utils/permissions.js
export function hasPermission(userPermissions, subject, action) {
  if (
    userPermissions[0]?.action == "manage" &&
    userPermissions[0]?.subject == "all"
  )
    return true;
  return userPermissions?.some(
    (permission) =>
      permission.subject === subject && permission.action === action
  );
}
